import {
    CREATE_STYLE_MASTER_FAILURE,
    CREATE_STYLE_MASTER_REQUEST,
    CREATE_STYLE_MASTER_SUCCESS,
    CREATE_USER_FORM_STYLE_MASTER,
    DELETE_STYLE_MASTER_FAILURE,
    DELETE_STYLE_MASTER_REQUEST,
    DELETE_STYLE_MASTER_SUCCESS,
    FETCH_STYLE_MASTER_FAILURE,
    FETCH_STYLE_MASTER_REQUEST,
    FETCH_STYLE_MASTER_SUCCESS,
    FETCH_SINGLE_STYLE_MASTER_FAILURE,
    FETCH_SINGLE_STYLE_MASTER_REQUEST,
    FETCH_SINGLE_STYLE_MASTER_SUCCESS,
    UPDATE_STYLE_MASTER_FAILURE,
    UPDATE_STYLE_MASTER_REQUEST,
    UPDATE_STYLE_MASTER_SUCCESS,
    STYLE_MASTER_USERFORM_RESET,
    FETCH_STYLE_MASTER_BY_ID_REQUEST,
    FETCH_STYLE_MASTER_BY_ID_SUCCESS,
    FETCH_STYLE_MASTER_BY_ID_FAILURE,
    FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_REQUEST,
    FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_SUCCESS,
    FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_FAILURE,
    CHECK_STITCHING_MEASUREMENT_BY_STYLE_REQUEST,
    CHECK_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS,
    CHECK_STITCHING_MEASUREMENT_BY_STYLE_FAILURE,
    CREATE_STITCHING_MEASUREMENT_BY_STYLE_REQUEST,
    CREATE_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS,
    CREATE_STITCHING_MEASUREMENT_BY_STYLE_FAILURE,
    UPDATE_STITCHING_MEASUREMENT_BY_STYLE_REQUEST,
    UPDATE_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS,
    UPDATE_STITCHING_MEASUREMENT_BY_STYLE_FAILURE,
    CREATE_USER_FORM_COPY_STYLE_MASTER,
    CREATE_COPY_STYLE_MASTER_PART_REQUEST,
    CREATE_COPY_STYLE_MASTER_PART_SUCCESS,
    CREATE_COPY_STYLE_MASTER_PART_FAILURE,
    COPY_STYLE_MASTER_USERFORM_RESET,
    FETCH_MULTI_COPY_STYLE_MASTER_REQUEST,
    FETCH_MULTI_COPY_STYLE_MASTER_SUCCESS,
    FETCH_MULTI_COPY_STYLE_MASTER_FAILURE,
    FETCH_MULTI_COPY_STYLE_COLOR_MASTER_REQUEST,
    FETCH_MULTI_COPY_STYLE_COLOR_MASTER_SUCCESS,
    FETCH_MULTI_COPY_STYLE_COLOR_MASTER_FAILURE,
    STYLE_MASTER_UPDATE_APPROVALSTATUS_REQUEST,
    STYLE_MASTER_UPDATE_APPROVALSTATUS_SUCCESS,
    STYLE_MASTER_UPDATE_APPROVALSTATUS_FAILURE,
    COPY_STYLE_MASTER_ASSIGN_COLOR_REQUEST,
    COPY_STYLE_MASTER_ASSIGN_COLOR_SUCCESS,
    COPY_STYLE_MASTER_ASSIGN_COLOR_FAILURE,
    CREATE_COPY_STYLE_MASTER_REQUEST,
    CREATE_COPY_STYLE_MASTER_SUCCESS,
    CREATE_COPY_STYLE_MASTER_FAILURE,
    SET_COPY_MODAL_VAR,
    SEND_VERIFY_OTP_USERFORM,
    SEND_VERIFY_OTP_USERFORM_REQUEST,
    SEND_VERIFY_OTP_USERFORM_SUCCESS,
    SEND_VERIFY_OTP_USERFORM_FAILURE,
    FETCH_COPY_STYLE_MASTER_REQUEST,
    FETCH_COPY_STYLE_MASTER_SUCCESS,
    FETCH_COPY_STYLE_MASTER_FAILURE,
    DELETE_COPY_STYLE_MASTER_REQUEST,
    DELETE_COPY_STYLE_MASTER_SUCCESS,
    DELETE_COPY_STYLE_MASTER_FAILURE,
    UPDATE_COPY_STYLE_MASTER_REQUEST,
    UPDATE_COPY_STYLE_MASTER_SUCCESS,
    UPDATE_COPY_STYLE_MASTER_FAILURE,
    CREATE_COPY_STYLE_MASTER_PART1_REQUEST,
    CREATE_COPY_STYLE_MASTER_PART1_SUCCESS,
    CREATE_COPY_STYLE_MASTER_PART1_FAILURE,
    FETCH_COPY_STYLE_MASTER1_REQUEST,
    FETCH_COPY_STYLE_MASTER1_SUCCESS,
    FETCH_COPY_STYLE_MASTER1_FAILURE,
    FETCH_STYLE_MASTER_DELETE_BY_ID_REQUEST,
    FETCH_STYLE_MASTER_DELETE_BY_ID_SUCCESS,
    FETCH_STYLE_MASTER_DELETE_BY_ID_FAILURE,
    COPY_STYLE_MASTER_USERFORM_RESET2,
    FILE_UPLOAD_DATA_REQUEST,
    FILE_UPLOAD_DATA_SUCCESS,
    FILE_UPLOAD_DATA_FAILURE,
    FILE_UPLOAD_DATA_GET_LIST_REQUEST,
    FILE_UPLOAD_DATA_GET_LIST_SUCCESS,
    FILE_UPLOAD_DATA_GET_LIST_FAILURE,
    CREATE_COPY_STYLE_MASTER_NEW_OPTION_REQUEST,
    CREATE_COPY_STYLE_MASTER_NEW_OPTION_SUCCESS,
    CREATE_COPY_STYLE_MASTER_NEW_OPTION_FAILURE,
    SIZE_MEASUREMENT_POST_DATA_REQUEST,
    SIZE_MEASUREMENT_POST_DATA_SUCCESS,
    SIZE_MEASUREMENT_POST_DATA_FAILURE,
    FETCH_COSTING_ACTIVE_ONLY_REQUEST,
    FETCH_COSTING_ACTIVE_ONLY_SUCCESS,
    FETCH_COSTING_ACTIVE_ONLY_FAILURE
} from './styleMaster.actionsType';
import { fetchDropdownProperty } from '../property/property.actions';
import { fetchGender, fetchSizeInfoData } from '../sizeInfo/sizeInfo.actions';
import { fetchBrandMaster } from '../brandMaster/brandMaster.actions';
import { fetchUnitMaster } from '../unitMaster/unitMaster.actions';
import { fetchSeasonMaster } from '../seasonMaster/seasonMaster.actions';
import { fetchPartyMasterData } from '../partyMaster/partyMaster.actions';
import { fetchProductDetails } from '../productDetails/productDetails.action';
import { fetchProductMasterData, fetchPropertyDataForProductMaster } from '../product/product.action';
import { fetchCommonPropertyById } from '../property/common/commonProperty.actions';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import { fetchCompanyMaster } from '../companyMaster/companyMaster.actions';
import { fetchColorDetailsWithoutId } from '../colorDetails/colorDetails.actions';
import Config from '../../config';
import Cookies from 'js-cookie';
import axios from 'axios';
import { LOADING_MODAL_CLOSE, MODAL_CLOSE } from '../actions';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

// FETCH StyleMaster
export let fetchStyleMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.styleMasterGET}`,
        responseTypeRequest: FETCH_STYLE_MASTER_REQUEST,
        responseTypeSuccess: FETCH_STYLE_MASTER_SUCCESS,
        responseTypeFailure: FETCH_STYLE_MASTER_FAILURE
    };
    return axiosCall(config);
};

export let fetchMultiCopyStyleMaster = (styleId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.multiCopyStyleMasterGET}?FldFKStyle=${styleId}`,
        responseTypeRequest: FETCH_MULTI_COPY_STYLE_MASTER_REQUEST,
        responseTypeSuccess: FETCH_MULTI_COPY_STYLE_MASTER_SUCCESS,
        responseTypeFailure: FETCH_MULTI_COPY_STYLE_MASTER_FAILURE
    };
    return axiosCall(config);
};

export let fetchCopyStyleColorMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.multiCopyColorStyleMasterGET}?CopyStyleDetailId=${id}`,
        responseTypeRequest: FETCH_MULTI_COPY_STYLE_COLOR_MASTER_REQUEST,
        responseTypeSuccess: FETCH_MULTI_COPY_STYLE_COLOR_MASTER_SUCCESS,
        responseTypeFailure: FETCH_MULTI_COPY_STYLE_COLOR_MASTER_FAILURE
    };
    return axiosCall(config);
};

export let fetchStyleMasterByID = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.styleMasterGET_BY_ID}/${id}`,
        responseTypeRequest: FETCH_STYLE_MASTER_BY_ID_REQUEST,
        responseTypeSuccess: FETCH_STYLE_MASTER_BY_ID_SUCCESS,
        responseTypeFailure: FETCH_STYLE_MASTER_BY_ID_FAILURE
    };
    return axiosCall(config);
};

export let fetchCostingActiveOnly = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.getCostingActiveOnly}`,
        responseTypeRequest: FETCH_COSTING_ACTIVE_ONLY_REQUEST,
        responseTypeSuccess: FETCH_COSTING_ACTIVE_ONLY_SUCCESS,
        responseTypeFailure: FETCH_COSTING_ACTIVE_ONLY_FAILURE
    };
    return axiosCall(config);
};

export let fetchStyleMasterDeleteDataByID = (id) => {
    return (dispatch) => {
        dispatch({ type: FETCH_STYLE_MASTER_DELETE_BY_ID_REQUEST });
        var config = {
            method: 'get',
            url: `${Config.baseUrl}${ConstantApi.styleMasterDeleteByGET_BY_ID}/${id}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                dispatch({ type: FETCH_STYLE_MASTER_DELETE_BY_ID_SUCCESS, updatePayload: response.data });
                if (response.data.length > 0) {
                    if (response?.data[0]?.fldRecordCount <= 0) {
                        dispatch(getSingleStyleMaster(id));
                    }
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_STYLE_MASTER_DELETE_BY_ID_FAILURE, updatePayload: error });
            });
    };
};

export let checkStitchingMeasurementByStyle = (style) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.styleMasterCheckMeasurementGET}/${style}`,
        responseTypeRequest: CHECK_STITCHING_MEASUREMENT_BY_STYLE_REQUEST,
        responseTypeSuccess: CHECK_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS,
        responseTypeFailure: CHECK_STITCHING_MEASUREMENT_BY_STYLE_FAILURE
    };
    return axiosCall(config);
};
export let fetchStyleMasterCheckDefaultValueByID = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.styleMasterCheckDefaultValueGET}/${parseInt(id)}`,
        responseTypeRequest: FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_REQUEST,
        responseTypeSuccess: FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_SUCCESS,
        responseTypeFailure: FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_FAILURE
    };
    return axiosCall(config);
};

export let createStyleMaster = (formData, modalClose, id) => {

    let today = new Date();
    let data = JSON.stringify({
        fldFKStyleMasterMain: parseInt(id),
        fldFKCompanyName: 0,
        fldFKSizeRatio: parseInt(formData.fldFKSizeRatio),
        isSampleArticle: true,
        fldCreationDt: today.toISOString(),
        fldSubStyleNumber: 'Auto Generated',
        fldCustStyleNumber: formData.fldCustStyleNumber,
        fldFKBuyerName: parseInt(formData.fldFKBuyerName),
        fldFKGender: parseInt(formData.fldFKGender),
        fldFKAgeRange: parseInt(formData.fldFKAgeRange),
        fldFKProdCategories: parseInt(formData.fldFKProdCategories),
        // fldCostingNo:  Costing FldStyleNumber,
        // fldFKCosting:  Costing Fldid,
        fldCostingNo: formData.fldCostingNo || "",
        fldFKCosting: parseInt(formData.fldFKCosting) || 0,
        fldItemTypeName: 'string',
        fldProdCategoriesName: 'string',
        fldProcessingLossPercentage: 0.0,
        fldPCSWeightGMs: 0.0,
        fldRequiredGSM: 0.0,
        fldFKItemType: parseInt(formData.fldFKItemType),
        // fldFKProductType: parseInt(formData.fldFKProductType),
        fldFKBrand: parseInt(formData.fldFKBrand),
        fldDescription: formData.fldDescription,
        fldFKSize: parseInt(formData.fldFKSize),
        fldColour: formData.fldColour.toString(), //formData.color
        fldFKMarket: parseInt(formData.fldFKMarket),
        fldFKCurrency: parseInt(formData.fldFKCurrency),
        fldExchangeRate: Number(formData.fldExchangeRate),
        fldExpBudgetRate: Number(formData.fldExpBudgetRate),
        fldConversion: Number(formData.fldConversion),
        fldIsSample: true,
        fldIsSeparatePacking: true,
        fldIsActive: true,
        fldEnteredSysId: formData.fldEnteredSysId,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldPreparedBy: 'string',
        fldPreparedOn: today.toISOString(),
        fldIsVerified: true,
        fldVerifiedBy: 'string',
        fldVerifiedOn: today.toISOString(),
        fldIsAuthorized: true,
        fldAuthorizedBy: 'string',
        fldAuthorizedOn: today.toISOString(),
        //  FldRequirementOption: formData.YarnFabricPO && formData.AccessoriesPO ? 'B' : formData.YarnFabricPO ? 'F' : formData.AccessoriesPO ? 'A' : formData.ReadyGarmentsPO ? 'R' : '',
        FldRequirementOption: formData.YarnFabricPO && formData.AccessoriesPO ? 'B' : formData.YarnFabricPO ? 'F' : formData.AccessoriesPO ? 'A' : '',
        fldIsGarment: formData.fldIsGarment,
        FldIsPartColourKG: false,
        FldProcessCount: 0,
        fldIsRatioPacking: formData.fldIsRatioPacking || false,
        fldPackingQtyPerBox: parseInt(formData.fldPackingQtyPerBox),
        fldPrintAccessCost: 0,
        fldOAPercentage: 0
    });
    // http://192.168.1.160/api/TblProperties/CreateTblProperties
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.styleMasterPOST}`,
        responseTypeRequest: CREATE_STYLE_MASTER_REQUEST,
        responseTypeSuccess: CREATE_STYLE_MASTER_SUCCESS,
        responseTypeFailure: CREATE_STYLE_MASTER_FAILURE,
        resetFormData: STYLE_MASTER_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchStyleMasterByID(id)
    };
    return axiosCall(config);
};

export let createCopyStyleMasterPart = (formData, modalClose, id) => {
    return (dispatch) => {
        dispatch({ type: CREATE_COPY_STYLE_MASTER_PART_REQUEST });
        var config = {
            method: 'post',
            data: JSON.stringify(formData),
            url: `${Config.baseUrl}${ConstantApi.copyStyleMasterPartPOST}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                dispatch({ type: CREATE_COPY_STYLE_MASTER_PART_SUCCESS, updatePayload: response?.data });
                dispatch({ type: COPY_STYLE_MASTER_USERFORM_RESET2 });
                dispatch(fetchMultiCopyStyleMaster(id));
                dispatch(fetchCopyStyleMasterById(response?.data?.fldID));
            })
            .catch((error) => {
                dispatch({ type: CREATE_COPY_STYLE_MASTER_PART_FAILURE, updatePayload: error });
            });
    };
};

export let createCopyStyleMasterPart1 = (formData, modalClose, id) => {
    return (dispatch) => {
        dispatch({ type: CREATE_COPY_STYLE_MASTER_PART1_REQUEST });
        var config = {
            method: 'post',
            data: JSON.stringify(formData),
            url: `${Config.baseUrl}${ConstantApi.copyStyleMasterPart1POST}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                dispatch({ type: CREATE_COPY_STYLE_MASTER_PART1_SUCCESS, updatePayload: response?.data });
                dispatch({ type: COPY_STYLE_MASTER_USERFORM_RESET2 });
                dispatch(fetchMultiCopyStyleMaster(id));
                dispatch(fetchCopyStyleMasterById1(response?.data?.fldID));
            })
            .catch((error) => {
                dispatch({ type: CREATE_COPY_STYLE_MASTER_PART1_FAILURE, updatePayload: error });
            });
    };
};

export let createStitchingMeasurementByStyle = (formData) => {
    let data = JSON.stringify(formData);
    // http://192.168.1.160/api/TblProperties/CreateTblProperties
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.createStitchingMeasurementPOST}`,
        responseTypeRequest: CREATE_STITCHING_MEASUREMENT_BY_STYLE_REQUEST,
        responseTypeSuccess: CREATE_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS,
        responseTypeFailure: CREATE_STITCHING_MEASUREMENT_BY_STYLE_FAILURE,

        headers: {
            'Content-Type': 'application/json'
        }
        // getAllData: fetchStyleMasterByID(id)
    };
    return axiosCall(config);
};

export let SendVerifyOTPMail = () => {
    let config = {
        method: 'post',
        // data: arrayData,
        url: `${ConstantApi.sendVerifyOTP}?FldStyleNo=KR779&FldSubStyleNo=KR779-001`,
        responseTypeRequest: SEND_VERIFY_OTP_USERFORM_REQUEST,
        responseTypeSuccess: SEND_VERIFY_OTP_USERFORM_SUCCESS,
        responseTypeFailure: SEND_VERIFY_OTP_USERFORM_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config);
};

export let updateStitchingMeasurementByStyle = (formData) => {
    let data = JSON.stringify(formData);
    // http://192.168.1.160/api/TblProperties/CreateTblProperties
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.updateStitchingMeasurementPATCH}`,
        responseTypeRequest: UPDATE_STITCHING_MEASUREMENT_BY_STYLE_REQUEST,
        responseTypeSuccess: UPDATE_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS,
        responseTypeFailure: UPDATE_STITCHING_MEASUREMENT_BY_STYLE_FAILURE,

        headers: {
            'Content-Type': 'application/json'
        }
        // getAllData: fetchStyleMasterByID(id)
    };
    return axiosCall(config);
};

export let StyleMasterUpdateApprovalStatus = (id, approvalid) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.styleMasterUpdateApprovalStatusBtn}?FldId=${id}&ApprovalStatus=${approvalid}`,
        responseTypeRequest: STYLE_MASTER_UPDATE_APPROVALSTATUS_REQUEST,
        responseTypeSuccess: STYLE_MASTER_UPDATE_APPROVALSTATUS_SUCCESS,
        responseTypeFailure: STYLE_MASTER_UPDATE_APPROVALSTATUS_FAILURE,
        singlApiArray: [getSingleStyleMaster(id)]
    };
    return axiosCall(config);
};

// GET SINGLE StyleMaster
export let getSingleStyleMaster = (id, boolean) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.styleMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_STYLE_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_STYLE_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_STYLE_MASTER_FAILURE,

        singlApiArray: boolean ? [] : [
            fetchDropdownProperty(),
            fetchSizeInfoData(),
            fetchBrandMaster(),
            fetchUnitMaster(),
            fetchSeasonMaster(),
            fetchPartyMasterData(),
            fetchCompanyMaster(),
            fetchColorDetailsWithoutId(),
            fetchGender(),
            // fetchColorMaster(),
            fetchProductDetails(),
            fetchProductMasterData(),
            fetchCommonPropertyById(8), //Age Range
            fetchCommonPropertyById(13), //Market
            fetchCommonPropertyById(39), //Currency Code
            fetchPropertyDataForProductMaster(9)
        ]
    };
    return axiosCall(config);
};

// fldPrintAccessCost
// fldOAPercentage
//UPDATE StyleMaster
export let updateStyleMaster = (formData, id) => {
    let today = new Date();
    let data = {
        fldId: formData.fldId,
        fldSubStyleNumber: formData.fldSubStyleNumber,
        fldFKSizeRatio: parseInt(formData.fldFKSizeRatio),
        fldFKStyleMasterMain: parseInt(id),
        fldFKCompanyName: parseInt(formData.fldFKCompanyName),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldCreationDt: formData.fldCreationDt,
        fldStyleNumber: formData.fldStyleNumber,
        fldCustStyleNumber: formData.fldCustStyleNumber,
        fldFKBuyerName: parseInt(formData.fldFKBuyerName),
        fldFKGender: parseInt(formData.fldFKGender),
        fldFKAgeRange: parseInt(formData.fldFKAgeRange),
        fldFKProdCategories: parseInt(formData.fldFKProdCategories),
        fldCostingNo: formData.fldCostingNo,
        fldFKCosting: parseInt(formData.fldFKCosting) || 0,
        fldFKItemType: parseInt(formData.fldFKItemType),
        fldItemTypeName: 'string',
        fldProdCategoriesName: 'string',
        // fldFKProductType: parseInt(formData.fldFKProductType),
        fldFKBrand: parseInt(formData.fldFKBrand),
        fldDescription: formData.fldDescription,
        fldFKSize: parseInt(formData.fldFKSize),
        fldColour: formData.fldColour.toString(), //formData.color
        fldFKMarket: parseInt(formData.fldFKMarket),
        fldFKCurrency: parseInt(formData.fldFKCurrency),
        fldExchangeRate: Number(formData.fldExchangeRate),
        fldExpBudgetRate: Number(formData.fldExpBudgetRate),
        fldConversion: Number(formData.fldConversion),
        fldIsSample: true,
        fldIsSeparatePacking: true,
        fldIsActive: true,
        fldEnteredSysId: formData.fldEnteredSysId,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldPreparedBy: formData.fldPreparedBy,
        // fldPreparedOn: formData?.fldPreparedOn,
        // fldIsVerified: formData.fldIsVerified,
        // fldVerifiedBy: formData.fldVerifiedBy,
        // fldVerifiedOn: formData?.fldVerifiedOn,
        // fldIsAuthorized: formData.fldIsAuthorized,
        // fldAuthorizedBy: formData.fldAuthorizedBy,
        fldProcessingLossPercentage: Number(formData.fldProcessingLossPercentage),
        fldPCSWeightGMs: Number(formData.fldPCSWeightGMs),
        fldRequiredGSM: Number(formData.fldRequiredGSM),
        //FldRequirementOption: formData.YarnFabricPO && formData.AccessoriesPO ? 'B' : formData.YarnFabricPO ? 'F' : formData.AccessoriesPO ? 'A' : formData.fldIsGarment ? 'R' : ''
        FldRequirementOption: formData.YarnFabricPO && formData.AccessoriesPO ? 'B' : formData.YarnFabricPO ? 'F' : formData.AccessoriesPO ? 'A' : '',
        // fldAuthorizedOn: formData?.fldVerifiedOn
        fldIsGarment: formData.fldIsGarment,
        FldIsPartColourKG: formData.FldIsPartColourKG,
        FldProcessCount: formData.FldProcessCount,
        fldIsRatioPacking: formData.fldIsRatioPacking || false,
        fldPackingQtyPerBox: parseInt(formData.fldPackingQtyPerBox),
        fldPrintAccessCost: formData.fldPrintAccessCost,
        fldOAPercentage: formData.fldOAPercentage
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.styleMasterPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_STYLE_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_STYLE_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_STYLE_MASTER_FAILURE,
        resetFormData: STYLE_MASTER_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchStyleMasterByID(id)
    };
    return axiosCall(config);
};

export let updateCopyStyleMaster = (styleId, checked) => {
    let config = {
        method: 'patch',
        // data,
        url: `${ConstantApi.copyStyleMasterPATCH}/${styleId},${checked}`,
        responseTypeRequest: UPDATE_COPY_STYLE_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_COPY_STYLE_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_COPY_STYLE_MASTER_FAILURE,
        // resetFormData: STYLE_MASTER_USERFORM_RESET,
        // modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchMultiCopyStyleMaster(styleId)
    };
    return axiosCall(config);
};

// DELETE StyleMaster
export let deleteStyleMaster = (id, parentId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.styleMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_STYLE_MASTER_REQUEST,
        responseTypeSuccess: DELETE_STYLE_MASTER_SUCCESS,
        responseTypeFailure: DELETE_STYLE_MASTER_FAILURE,
        modalClose: true,
        resetFormData: STYLE_MASTER_USERFORM_RESET,
        getAllData: fetchStyleMasterByID(parentId)
    };
    return axiosCall(config);
};

export let deleteCopyStyleMaster = (id, styleId) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.copyStyleMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_COPY_STYLE_MASTER_REQUEST,
        responseTypeSuccess: DELETE_COPY_STYLE_MASTER_SUCCESS,
        responseTypeFailure: DELETE_COPY_STYLE_MASTER_FAILURE,
        // modalClose: true,
        // resetFormData: STYLE_MASTER_USERFORM_RESET,
        getAllData: fetchMultiCopyStyleMaster(styleId)
    };
    return axiosCall(config);
};

export let createStyleUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_STYLE_MASTER, payload: { key, value } });
    };
};

export let createCopyStyleUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_COPY_STYLE_MASTER, payload: { key, value } });
    };
};

export let CopyStyleMasterAssignColor = (id, fldFKColor, fldColor, styleId, renderGridBtn) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.copyStyleMasterAssignColor
            }/${id}?FldFKNewColour=${fldFKColor?.toString()}&FldNewColour=${fldColor?.toString()}&FldCopyOption=${renderGridBtn}`,
        responseTypeRequest: COPY_STYLE_MASTER_ASSIGN_COLOR_REQUEST,
        responseTypeSuccess: COPY_STYLE_MASTER_ASSIGN_COLOR_SUCCESS,
        responseTypeFailure: COPY_STYLE_MASTER_ASSIGN_COLOR_FAILURE,
        singlApiArray: [fetchMultiCopyStyleMaster(styleId)] //
    };
    return axiosCall(config);
};

export let createCopyStyleMaster = (id, check) => {
    return (dispatch) => {
        dispatch({ type: CREATE_COPY_STYLE_MASTER_REQUEST });
        var config = {
            method: 'post',
            // data: JSON.stringify(formData),
            url: `${Config.baseUrl}${ConstantApi.createCopyStyleMasterPOST}?FldFKStyleMaster=${id}&FldIsCopyStyleMain=${check}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                dispatch({ type: CREATE_COPY_STYLE_MASTER_SUCCESS, updatePayload: response?.data });
                dispatch({ type: COPY_STYLE_MASTER_USERFORM_RESET });
                dispatch({ type: SET_COPY_MODAL_VAR, payload: false });
                dispatch({ type: MODAL_CLOSE });
                // toast.success(response?.data, { autoClose: 1500 });
                Swal.fire({
                    icon: 'success',
                    text: `Please note down your ${response?.data}`
                });
            })
            .catch((err) => {
                toast.error(err?.response?.data['']?.errors[0]?.errorMessage ?? err?.response?.data?.title ?? err?.response?.data);
                dispatch({ type: CREATE_COPY_STYLE_MASTER_FAILURE, updatePayload: err });
            });
    };
};


export let createCopyStyleMasterNewOption = (id, btnname, salesOrderNo, styleNo) => {
    return (dispatch) => {
        dispatch({ type: CREATE_COPY_STYLE_MASTER_NEW_OPTION_REQUEST });
        var config = {
            method: 'post',
            // data: JSON.stringify(formData),
            url: `${Config.baseUrl}${ConstantApi.createCopyStyleMasterOneNewPOST}?FldFKStyleMaster=${id}&FldCopyOption=${btnname}&FldSaleOrderNo=${salesOrderNo}&FldFKDestination=${styleNo}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };

        axios(config)
            .then((response) => {
                dispatch({ type: CREATE_COPY_STYLE_MASTER_NEW_OPTION_SUCCESS, updatePayload: response?.data });
                dispatch({ type: COPY_STYLE_MASTER_USERFORM_RESET });
                dispatch({ type: SET_COPY_MODAL_VAR, payload: false });
                dispatch({ type: MODAL_CLOSE });
                // toast.success(response?.data, { autoClose: 1500 });
                Swal.fire({
                    icon: 'success',
                    text: `Please note down your ${response?.data}`
                });

            })
            .catch((err) => {
                toast.error(err?.response?.data['']?.errors[0]?.errorMessage ?? err?.response?.data?.title ?? err?.response?.data);
                dispatch({ type: CREATE_COPY_STYLE_MASTER_NEW_OPTION_FAILURE, updatePayload: err });
            });
    };
};

// export let createCopyStyleMaster = (id, check) => {
//     let config = {
//         method: 'post',
//         url: `${ConstantApi.createCopyStyleMasterPOST}?FldFKStyleMaster=${id}&FldIsCopyStyleMain=${check}`,
//         responseTypeRequest: CREATE_COPY_STYLE_MASTER_REQUEST,
//         responseTypeSuccess: CREATE_COPY_STYLE_MASTER_SUCCESS,
//         responseTypeFailure: CREATE_COPY_STYLE_MASTER_FAILURE,
//         resetFormData: COPY_STYLE_MASTER_USERFORM_RESET,
//         modalClose: true,
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         singlApiArray: [{ type: SET_COPY_MODAL_VAR, payload: false }]
//         // getAllData: fetchStyleMasterByID(id)
//     };
//     return axiosCall(config);
// };

export let fetchCopyStyleMasterById = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.copyStyleMasterGET}/${id}`,
        responseTypeRequest: FETCH_COPY_STYLE_MASTER_REQUEST,
        responseTypeSuccess: FETCH_COPY_STYLE_MASTER_SUCCESS,
        responseTypeFailure: FETCH_COPY_STYLE_MASTER_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
        // singlApiArray: [{ type: SET_COPY_MODAL_VAR, payload: false }]
        // getAllData: fetchStyleMasterByID(id)
    };
    return axiosCall(config);
};

export let fetchCopyStyleMasterById1 = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.copyStyleMaster1GET}/${id}`,
        responseTypeRequest: FETCH_COPY_STYLE_MASTER1_REQUEST,
        responseTypeSuccess: FETCH_COPY_STYLE_MASTER1_SUCCESS,
        responseTypeFailure: FETCH_COPY_STYLE_MASTER1_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
        // singlApiArray: [{ type: SET_COPY_MODAL_VAR, payload: false }]
        // getAllData: fetchStyleMasterByID(id)
    };
    return axiosCall(config);
};

export let fileUploadDataPost = (data, id) => {
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.fileUploadStyle}?FldFkStyle=${id}`,
        responseTypeRequest: FILE_UPLOAD_DATA_REQUEST,
        responseTypeSuccess: FILE_UPLOAD_DATA_SUCCESS,
        responseTypeFailure: FILE_UPLOAD_DATA_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        },
        singlApiArray: [fileUploadDataGetlist(id)]

    };
    return axiosCall(config);
};

export let postMeasurementData = (data, id) => {
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.getSizeMeasurement}`,
        responseTypeRequest: SIZE_MEASUREMENT_POST_DATA_REQUEST,
        responseTypeSuccess: SIZE_MEASUREMENT_POST_DATA_SUCCESS,
        responseTypeFailure: SIZE_MEASUREMENT_POST_DATA_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchStyleMasterByID(id)


    };
    return axiosCall(config);
};

export let fileUploadDataGetlist = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fileUploadGetList}?FldFkStyle=${id}`,
        responseTypeRequest: FILE_UPLOAD_DATA_GET_LIST_REQUEST,
        responseTypeSuccess: FILE_UPLOAD_DATA_GET_LIST_SUCCESS,
        responseTypeFailure: FILE_UPLOAD_DATA_GET_LIST_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }

    };
    return axiosCall(config);
};



